import Typography from '@/ui/components/typography'
import { PlayButton } from '@/ui/components/buttons/PlayButton'
import { Circle } from '@/ui/components/circle/circle.styles'
import GearIcon from '@assets/images/gear-icon.svg?react'
import VerifyIcon from '@assets/images/verify-icon.svg?react'
import FraudDefenseMarketingImage from '@assets/images/fraud-defense-marketing.svg?react'
import {
    HeroSectionContainer,
    FeatureList,
    FeatureItem,
    ImageWrapper,
    HeroTitle,
} from '../FraudDefenseMarketing.styles'
import { DialogService } from '@/core/services/dialog/dialog.service'
import { ASM_DIALOGS_MAP } from '@/core/services/dialog/dialog.service.config'
import { Analytics } from '@/core/services/mixpanel/mixpanel.service'

const HeroSection = () => {
    const handleDiscoverFraudDefense = () => {
        Analytics.event('SEM::fraud_defense_see_why_video_modal_open')
        DialogService.showDialog(ASM_DIALOGS_MAP.FRAUD_DEFENSE_VIDEO)
    }

    return (
        <HeroSectionContainer>
            <div>
                <HeroTitle
                    variant="xxxl-regular"
                    testId="fraud-defense-marketing-title"
                >
                    Protect Your Business from Email-based Financial Fraud
                </HeroTitle>
                <Typography variant="m-light">
                    Connect your accounts to detect and block financial fraud
                    emails before any losses occur
                </Typography>
                <PlayButton
                    onClick={handleDiscoverFraudDefense}
                    data-testid="discover-fraud-defense-button"
                    text="Discover Fraud Defense"
                />
                <FeatureList>
                    <FeatureItem>
                        <GearIcon />
                        <Typography variant="s-light">
                            Quick & Easy Setup
                        </Typography>
                    </FeatureItem>
                    <Circle />
                    <FeatureItem>
                        <VerifyIcon />
                        <Typography variant="s-light">
                            No License Required
                        </Typography>
                    </FeatureItem>
                </FeatureList>
            </div>
            <ImageWrapper>
                <FraudDefenseMarketingImage data-testid="fraud-defense-marketing-image" />
            </ImageWrapper>
        </HeroSectionContainer>
    )
}

export default HeroSection
